export const IMPERSONATION_BANNER_CLOSED_KEY = 'marqii:global/impersonation-banner-closed'
